<template>
  <v-dialog
      scrollable
      v-model="visible"
      max-width="900px"
      :fullscreen="fullscreen"
      :persistent="true"
  >
    <v-card>
      <v-toolbar flat dense>
        <v-toolbar-title class="subheading">{{ title }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="fullscreen=!fullscreen">
          <v-icon>fullscreen</v-icon>
        </v-btn>
      </v-toolbar>

      <v-divider style="max-height: 1px"/>
      <v-progress-linear class="my-0" :indeterminate="true" :active="loading" height="2"/>

      <v-card-text>
        <v-form v-model="formValid" ref="formRef" lazy-validation>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field
                    label="联合申报项目名称"
                    :rules="rules.required"
                    v-model="item.name"/>
              </v-flex>

              <v-flex xs12 sm6>
                <x-user-select-form
                    label="项目负责人"
                    :rules="rules.required"
                    v-model="leader"
                    hint="输入关键词，检索添加本单位项目负责人；或直接录入外单位项目负责人。"
                    persistent-hint
                />
              </v-flex>

              <v-flex xs12 sm6>
                <v-text-field
                    label="负责人联系电话"
                    :rules="rules.required"
                    v-model="item.leaderPhone"/>
              </v-flex>

              <v-flex xs12 sm6>
                <v-autocomplete
                    label="归属部门"
                    clearable
                    :rules="rules.required"
                    v-model="item.deptId"
                    item-text="name"
                    item-value="dbid"
                    :items="deptItems"
                />
              </v-flex>

              <v-flex xs12 sm6>
                <v-select
                    label="主管部门"
                    clearable
                    required
                    :rules="rules.required"
                    v-model="item.adminDeptId"
                    item-text="name"
                    item-value="dbid"
                    :items="deptItems.filter(d => d.isAdmin)"
                />
              </v-flex>

              <v-flex xs12 sm8>
                <v-text-field
                    label="合作单位名称"
                    :rules="rules.normal"
                    v-model="item.client"
                />
              </v-flex>

              <v-flex xs12 sm4>
                <v-select
                    label="合作单位性质"
                    clearable
                    :rules="rules.required"
                    v-model="item.clientTypeId"
                    item-text="name"
                    item-value="dbid"
                    :items="orgnTypeItems"
                />
              </v-flex>


              <v-flex xs12>
                <v-text-field
                    label="备注"
                    v-model="item.note"
                />
              </v-flex>

              <v-flex xs12>
                <x-uploader
                    label="附件列表"
                    :action="fileUri"
                    v-model="item.attachments"
                    :size="Number(20)"
                    :description="[
                    '单个附件大小不超过 20M.',
                    '推荐上传 PDF 格式文件.'
                  ]"
                />
              </v-flex>

            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer/>
        <v-btn color="blue darken-1" flat @click.native="visible = false">取消</v-btn>
        <v-btn color="primary" @click.native="onSave">保存
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>

import mixin from '@/mixin'

import XUploader from '@/components/global/Uploader'
import XUserSelectForm from '@/components/global/UserSelectForm'

const baseURI = '/api/coop/cooperation';
const typeURI = '/api/proj/project-type';
const orgnTypeURI = '/api/coop/orgn-type';
const deptURI = '/api/syst/department';
const indstTypeUri = '/api/proj/industry-type/flatten/tree';

export default {
  mixins: [mixin.edit(baseURI)],
  components: {XUserSelectForm, XUploader},

  data() {
    return {
      formValid: false,

      fileUri: '/api/agmt/file',

      item: {},
      freshItem: {
        "name": null,
        "adminDeptId": null,
        "deptId": null,
        "leaderId": null,
        "leaderName": null,
        "statusId": null,
        "typeId": null,
        "property": null,
        "trade": null,
        "client": null,
        "clientTypeId": null,
        "amount": null,
        "bidding": null,
        "applDate": null,
        "leaderPhone": null,
        "startDate": null,
        "finishDate": null,
        "turnover": null
      },

      leader: {},

      startDateMenu: false,
      startDate: null,

      endDateMenu: false,
      finishDate: null,

      typeItems: [],
      orgnTypeItems: [],
      deptItems: [],

      indstTypeItems: [],

      /**
       * 验证规则
       */
      rules: {
        required: [
          v => !!v || '必填项。'
        ],
        bidding: [
          v => (v === true || v === false) || '必填项。'
        ],
        normal: [
          v => !!v || '必填项。',
          v => (v && v.length <= 100) || '长度必须小于100个字符。'
        ],
        amount: [
          v => !!v || '必填项。',
          v => (v && /^\d{1,10}?(.[0-9][0-9]?)?$/ig.test(v)) || '填写数字，小数点后最多保留2位。'
        ],
        email: [
          v => (!v || /^[\w.-]+@(?:[a-z0-9]+(?:-[a-z0-9]+)*\.)+[a-z]{2,3}$/ig.test(v)) || '邮箱格式不正确。'
        ],

        startDate: [
          v => !!v || "必填项。",
          v => window.xutil.regexpDate().test(v) || '日期格式错误'
        ],
        finishDate: [
          v => !!v || "必填项。",
          v => (v && window.xutil.regexpDate().test(v)) || '日期格式错误',
          v => (v && v > this.item.startDate) || "截止日期必须晚于起始日期。"
        ]
      }
    }
  },

  created() {
    this.indstTypeLoading = true;

    this.axios.all([
      this.axios.get(deptURI, {params: {limit: 65535, disabled: 'F'}}),
      // 只取 横向合同 的子项
      this.axios.get(typeURI, {params: {limit: 65535, disabled: 'F', parentId: 'Db2NlYTLADg'}}),
      this.axios.get(orgnTypeURI, {params: {limit: 65535, disabled: 'F', sort: 'order.asc'}}),
      this.axios.get(indstTypeUri)
    ]).then(
        this.axios.spread(
            (rspDept, rspType, rspOrgnType, rspIndst) => {
              this.deptItems = rspDept.data.items;
              this.typeItems = rspType.data.items;
              this.orgnTypeItems = rspOrgnType.data.items;

              this.indstTypeLoading = false;
              this.indstTypeItems = rspIndst.data.reduce(
                  (acc, v, i) => {
                    if (!v.leaf) {
                      if (i > 0)
                        acc.push({divider: true}, {header: v.name});
                      else
                        acc.push({header: v.name});
                    } else {
                      acc.push(v);
                    }
                    return acc;
                  }, []);
            }
        )
    )
  },

  watch: {
    "leader": function (v) {
      this.item.leaderId = v.userId;
      this.item.leaderName = v.name;

      if (v && v.deptId) this.item.deptId = v.deptId;

      if (v && v.phone) this.item.leaderPhone = v.phone;
    }
  },

  methods: {
    // mixin 加载数据后调用
    afterGetData(data) {
      this.leader = {
        userId: data.leaderId,
        name: data.leaderName
      }
    },
  }
}
</script>
